import styled from 'styled-components';
import { color } from 'styles/settings';

export const LinkMark = styled.span`
  position: absolute;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1;
  border-right: 2.5px solid ${color.brand.blue};
  background-color: transparent;
`;
